import { useState } from "react";
import { Menu, X } from "lucide-react";
import logoImg from "@/assets/images/logo.jpg";

const LINKS = [
  { label: "Roles", href: "#roles" },
  { label: "Workflow", href: "#workflow" },
  { label: "Modules", href: "#modules" },
  { label: "Integrations", href: "#integrations" },
  { label: "ROI", href: "#roi" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="navbar"
      className="fixed top-0 inset-x-0 z-50 bg-slate-950/85 backdrop-blur-md border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2.5">
          <img
            src={logoImg}
            alt="CTEMS Logo"
            className="w-9 h-9 rounded-lg object-contain shrink-0"
          />
          <span className="font-heading font-bold text-lg tracking-tight text-white">
            CTEMS
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm text-slate-300 hover:text-white transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#demo"
            data-testid="nav-request-demo-button"
            className="px-5 py-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold transition-colors duration-200 active:scale-95"
          >
            Request a Demo
          </a>
        </div>

        <button
          data-testid="nav-mobile-menu-button"
          className="md:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden bg-slate-950 border-t border-white/10 px-6 py-4 space-y-3">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              onClick={() => setOpen(false)}
              className="block text-sm text-slate-300 hover:text-white py-1"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#demo"
            data-testid="nav-mobile-request-demo-button"
            onClick={() => setOpen(false)}
            className="block w-full text-center px-5 py-2.5 rounded-md bg-blue-600 text-white text-sm font-semibold"
          >
            Request a Demo
          </a>
        </div>
      )}
    </header>
  );
};
